import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import type { EnvelopeListDto } from '@lib/dto/envelope.dto'
import type { OpsEnvelopeSearchQuery } from '@lib/input/envelope.input'
import { useEnvelopeAccess } from '@/envelopes/EnvelopeAccess'
import { envelopeKeys } from '@/hooks/queryKeys'
import { keepPreviousWithin } from '@/hooks/keepPreviousWithin'

/** One page of envelopes for the current surface. Keeps the last page of the same scope on screen while the next loads. */
export function useEnvelopes(query?: OpsEnvelopeSearchQuery): UseQueryResult<EnvelopeListDto> {
  const { service, cacheKey } = useEnvelopeAccess()
  return useQuery({
    queryKey: envelopeKeys.list(cacheKey, query ?? {}),
    queryFn: () => service.list(query),
    placeholderData: keepPreviousWithin(envelopeKeys.scope(cacheKey)),
  })
}
